var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contratos-toolbar-contratos-ejecucion"}},[_c('v-toolbar',{attrs:{"flat":""}},[(_vm.regresar)?[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":_vm.botonRegresar}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("\n              fa-arrow-left\n            ")])],1)]}}],null,false,2346092631)},[_c('span',[_vm._v("Regresar")])])]:_vm._e(),_c('v-toolbar-title',{class:{
      'display-1': !_vm.$vuetify.breakpoint.xs,
      'display-0': _vm.$vuetify.breakpoint.xs
      }},[_vm._v("\n      "+_vm._s(_vm.titulo)+"\n    ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }